<template>
  <div class="error-page">
    <div class="error">
      <img
        src="../../static/img/error.png"
        style="width: 40%; border-radius: 4px; margin-top: -40px"
        alt=""
      />
      <el-button type="primary" style="margin-top: 20px" @click="goHome"
        >返回首页</el-button
      >
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from './common/footer.vue'
export default {
  name: 'error',
  components: { Footer },
  methods: {
    goHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.error-page {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.error {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.title {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/405.vue